import { useEffect, useState } from "react";

function Posts() {
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState(null);
  const apiUrl = import.meta.env.VITE_STRAPI_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/posts`)
      .then((res) => res.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setPosts(data.data);
        } else {
          setError("La respuesta no tiene el formato esperado");
        }
      })
      .catch((err) => {
        console.error("Error al conectar con el backend:", err);
        setError("Error en la conexión con el backend");
      });
  }, [apiUrl]);

  if (error) return <div className="text-danger">Error: {error}</div>;
  if (posts === null) return <div>Cargando publicaciones...</div>;
  if (posts.length === 0) return <div>No hay publicaciones</div>;

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Posts</h1>
      <div className="row">
        {posts.map((post) => (
          <div className="col-md-4 mb-4" key={post.id}>
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">{post.Nombre}</h5>
                <p className="card-text">
                  <strong>Document ID:</strong> {post.documentID}
                </p>
                <p className="card-text">
                  <strong>Número:</strong> {post.Number}
                </p>
                <p className="card-text">
                  <strong>Fecha de creación:</strong> {post.createdAt}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Posts;